module.exports = __webpack_public_path__ + "media/images/icons/outlined/form-6777316215d723024233e8c866d853ff.svg";